<!--
 * @Descripttion: 我的
 * @FilePath: /mall-wap-vue/src/views/mine/index.vue
 * @Author: 张兴业
 * @Date: 2020-09-24 15:39:27
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2020-12-30 20:53:00
-->
<template>
  <div class="mine_con font0">
    <!-- 头部信息 -->
    <top-personal class="top_info" />
    <!-- 我的订单 -->
    <div class="my_order">
      <my-order @goList="goList" />
    </div>
    <!-- 服务 -->
    <az-services class="service" @goService="goService" />
    <!-- 图片 -->
    <div class="mine_recom">
      <img src="@/assets/mine/bg_mine@2x.png" alt="" />
    </div>
    <!-- 猜你喜欢 -->
    <!-- <div class="love_bottom">
      <you-love />
      <recommend />
    </div> -->
  </div>
</template>
<script>
const TopPersonal = () =>
  import("./components/TopPersonal").then(m => m.default || m);
import MyOrder from "./components/MyOrder";
import AzServices from "./components/AzServices";
// import YouLove from "@/components/YouLove";
// import Recommend from "@/components/Recommend";
export default {
  components: {
    TopPersonal,
    MyOrder,
    AzServices
    // YouLove,
    // Recommend
  },
  computed: {
    getUserInfo() {
      return this.$store.getters.getUserInfo;
    }
    // queryCardVoucherUserCount() {
    //   return this.$store.getters.queryCardVoucherUserCount;
    // }
  },
  created() {
    this.getData();
    localStorage.removeItem("mall-order-list-index");
    // this.getCardData();
  },
  methods: {
    getData() {
      // getUserInfo
      this.$store
        .dispatch("mine/getUserInfo")
        .then(() => {})
        .catch(() => {});
    },
    // 卡券数量接口
    // getCardData() {
    //   // getUserInfo
    //   this.$store
    //     .dispatch("mine/queryCardVoucherUserCount")
    //     .then(() => {})
    //     .catch(() => {});
    // },
    goList(path, index) {
      localStorage.setItem("mall-order-list-index", index);
      this.$router.push(path);
    },
    goService() {
      this.$router.push("/mine/question/list");
    }
  }
};
</script>
<style lang="less" scoped>
.mine_con {
  margin-bottom: 50px;
}
.top_info {
  z-index: -1;
}
.mine_recom {
  margin: 0 12px;
  img {
    width: 100%;
    display: block;
  }
}

// .love_bottom {
//   background: #fff;
// }
</style>
